import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({
  name: 'translateDuration'
})
export class FormatDatePipePipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {}

  transform(duration: string, inThePast = true): Observable<any> {
    return this.translate.get(inThePast ? 'time.@ago' : 'time.@in', { duration: duration });
  }

}
